










import Vue from "vue";
import { useStore } from "@/store/store";
import { mapStores } from "pinia";
import { PythonExecRunningState } from "@/types/types";
import scssVars from "@/assets/style/_export.module.scss";

/**
 * Caret is used as a vertical cursor for browsing
 * throughout the code's frames and showing where
 * a frame will be droped when dragged.
 */

export default Vue.extend({
    name: "Caret",

    props: {
        isInvisible: Boolean,
        areFramesDraggedOver: Boolean,
        areDropFramesAllowed: Boolean,
        isDuplicateDnDAction: Boolean,
    },

    computed: {
        ...mapStores(useStore),

        isPythonExecuting(): boolean {
            return (this.appStore.pythonExecRunningState ?? PythonExecRunningState.NotRunning) != PythonExecRunningState.NotRunning;
        },

        scssVars() {
            // just to be able to use in template
            return scssVars;
        },
    },
});
